import { render, staticRenderFns } from "./coupon_list.vue?vue&type=template&id=640d846a"
import script from "./coupon_list.vue?vue&type=script&lang=js"
export * from "./coupon_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports